import fetch from "isomorphic-fetch"
import * as config from "./config"
import getJamFilledCookie from "./getJamFilledCookie"
import getUserIdFromJamFilledCookie from "./getUserIdFromJamFilledCookie"
import getUserIdFromLocalStorage from "./getUserIdFromLocalStorage"

export default async function isPermissioned(JAM_ID: string): Promise<boolean> {
	const res = await fetch(
		`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/check_user_allowed`,
		{
			method: "POST",
			headers: {
				"content-type": "application/json",
				"jam-filled-cookie": getJamFilledCookie(),
				"jam-filled-userid": getUserIdFromLocalStorage(),
			},
			body: JSON.stringify({ userId: getUserIdFromJamFilledCookie() }),
		},
	)

	const json = await res.json()

	return json.allowed
}
